export default __webpack_public_path__ + "static/media/T_Tatu.aefa5767.mp3";